import React from "react";
import { SSH_FeatureHandler } from "../../../../helpers/FeatureHandler.helper";
import V1 from "./v1/TitleV1.component";

const featureName = "blockPLPSeoTitle";
const versions = {
    v1: V1,
};

// eslint-disable-next-line unused-imports/no-unused-vars
export const SSH_SeoTitle = React.forwardRef(({ version, ...props }: any, ref: any) => (
    <SSH_FeatureHandler
        featureName={featureName}
        featureVersions={versions}
        version={version}
        {...props}
    />
));

SSH_SeoTitle.displayName = "SSH_SeoTitle";
